'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AddZendeskScreenNamePopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/AddZendeskScreenNamePopup');

var _AddZendeskScreenNamePopup2 = _interopRequireDefault(_AddZendeskScreenNamePopup);

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZendeskScreenNamePopupContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(ZendeskScreenNamePopupContainer, _React$Component);

  function ZendeskScreenNamePopupContainer(props) {
    (0, _classCallCheck3.default)(this, ZendeskScreenNamePopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ZendeskScreenNamePopupContainer.__proto__ || (0, _getPrototypeOf2.default)(ZendeskScreenNamePopupContainer)).call(this, props));

    _this.state = {
      error: ''
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.getFileBase64Src = _this.getFileBase64Src.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ZendeskScreenNamePopupContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.screenNameError && nextProps.screenNameError !== this.props.screenNameError) {
        this.props.onCloseYes();
      }
    }
  }, {
    key: 'getFileBase64Src',
    value: function getFileBase64Src(imgSrc) {
      this.props.setZendeskAvatar(imgSrc[0].replace(/^data:image\/[a-z]+;base64,/, ""));
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(screenName) {
      this.props.setZendeskScreenName(screenName);

      //this.props.onCloseYes()
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          fileUploading = _props.fileUploading,
          loggingIn = _props.loggingIn,
          screenNameError = _props.screenNameError;

      return _react2.default.createElement(_AddZendeskScreenNamePopup2.default, {
        icon: '/quixel_2080_logo.png',
        fileHandler: this.getFileBase64Src,
        onSubmitHandler: this.handleSubmit,
        error: screenNameError,
        fileUploading: fileUploading,
        loading: loggingIn
      });
    }
  }]);
  return ZendeskScreenNamePopupContainer;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    screenName: state.auth.screenName,
    screenNameError: state.auth.screenNameError && state.auth.screenNameError.message,
    fileUploading: state.auth.fileUploading,
    loggingIn: state.auth.loggingIn
  };
}, { setZendeskScreenName: _auth.setZendeskScreenName, setZendeskAvatar: _auth.setZendeskAvatar })(ZendeskScreenNamePopupContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ZendeskScreenNamePopupContainer/ZendeskScreenNamePopupContainer.jsx
// module id = 2815
// module chunks = 0